import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';
import { WALL_POST_TEMPLATES, TEMPLATE_CATEGORIES, PostTemplate } from './wallPostTemplates';

interface TemplatePickerModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSelectTemplate: (template: PostTemplate) => void;
}

const TemplatePickerModal: React.FC<TemplatePickerModalProps> = ({
  open,
  onOpenChange,
  onSelectTemplate,
}) => {
  const categories = Object.entries(TEMPLATE_CATEGORIES) as [keyof typeof TEMPLATE_CATEGORIES, typeof TEMPLATE_CATEGORIES[keyof typeof TEMPLATE_CATEGORIES]][];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[80vh]">
        <DialogHeader>
          <DialogTitle>Choose a Template</DialogTitle>
          <DialogDescription>
            Select a structured post format to share your story
          </DialogDescription>
        </DialogHeader>
        <ScrollArea className="h-[60vh] pr-4">
          <div className="space-y-6">
            {categories.map(([categoryId, category]) => {
              const templates = WALL_POST_TEMPLATES.filter(t => t.category === categoryId);
              if (templates.length === 0) return null;

              return (
                <div key={categoryId}>
                  <h3 className="text-sm font-semibold text-muted-foreground mb-2 flex items-center gap-2">
                    <span>{category.emoji}</span>
                    <span>{category.label}</span>
                  </h3>
                  <div className="space-y-2">
                    {templates.map((template) => (
                      <Button
                        key={template.id}
                        variant="outline"
                        className="w-full h-auto py-3 px-4 flex flex-col items-start text-left hover:bg-accent"
                        onClick={() => {
                          onSelectTemplate(template);
                          onOpenChange(false);
                        }}
                      >
                        <div className="flex items-center gap-2 mb-1">
                          <span className="text-base">{template.displayEmojis.slice(0, 2).join(' ')}</span>
                          <span className="font-semibold text-sm">{template.name}</span>
                        </div>
                        <span className="text-xs text-muted-foreground font-normal">
                          {template.description}
                        </span>
                      </Button>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default TemplatePickerModal;
